export const getFormattedAddress = (
  address1,
  address2,
  city,
  province,
  country,
  postalcode,
  lines,
) => {
  let response = [];
  let finalAddress;
  //for address1 and address2
  if (address1 != "" && address1 != null && address2 != "" && address2 != null)
    response.push(address1.trim() + ", " + address2);
  else if (
    address1 != "" &&
    address1 != null &&
    (address2 == "" || address2 == null)
  )
    response.push(address1);
  else if (
    (address1 == "" || address1 == null) &&
    address2 != "" &&
    address2 != null
  )
    response.push(address2);
  else if (
    (address1 == "" || address1 == null) &&
    (address2 == "" || address2 == null)
  )
    response.push("");
  // for city, province and postal code
  if (country != "United Kingdom") {
    if (
      city != "" &&
      city != null &&
      province != "" &&
      province != null &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(city + ", " + province + ", " + postalcode);
    else if (
      city != "" &&
      city != null &&
      province != "" &&
      province != null &&
      (postalcode == "" || postalcode == null)
    )
      response.push(city + ", " + province);
    else if (
      city != "" &&
      city != null &&
      (province == "" || province == null) &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(city + ", " + postalcode);
    else if (
      (city == "" || city == null) &&
      province != "" &&
      province != null &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(province + " " + postalcode);
    else if (
      (city == "" || city == null) &&
      (province == "" || province == null) &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(postalcode);
    else if (
      (city == "" || city == null) &&
      province != "" &&
      province != null &&
      (postalcode == "" || postalcode == null)
    )
      response.push(province);
    else if (
      city != "" &&
      city != null &&
      (province == "" || province == null) &&
      (postalcode == "" || postalcode == null)
    )
      response.push(city);
    else if (
      (city == "" || city != null) &&
      (province == "" || province == null) &&
      (postalcode == "" || postalcode == null)
    )
      response.push("");
  } else {
    if (
      city != "" &&
      city != null &&
      province != "" &&
      province != null &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(city + ", " + postalcode);
    else if (
      city != "" &&
      city != null &&
      province != "" &&
      province != null &&
      (postalcode == "" || postalcode == null)
    )
      response.push(city);
    else if (
      city != "" &&
      city != null &&
      (province == "" || province == null) &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(city + ", " + postalcode);
    else if (
      (city == "" || city == null) &&
      province != "" &&
      province != null &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(postalcode);
    else if (
      (city == "" || city == null) &&
      (province == "" || province == null) &&
      postalcode != "" &&
      postalcode != null
    )
      response.push(postalcode);
    else if (
      (city == "" || city == null) &&
      province != "" &&
      province != null &&
      (postalcode == "" || postalcode == null)
    )
      response.push("");
    else if (
      city != "" &&
      city != null &&
      (province == "" || province == null) &&
      (postalcode == "" || postalcode == null)
    )
      response.push(city);
    else if (
      (city == "" || city != null) &&
      (province == "" || province == null) &&
      (postalcode == "" || postalcode == null)
    )
      response.push("");
  }
  //for country
  if (country != "" && country != null) response.push(country);
  else if (country == "" || country == null) response.push("");
  //updated address
  if (lines == 1) {
    if (response[0] != "" && response[1] != "" && response[2] != "")
      finalAddress =
        response[0].trim() +
        ", " +
        response[1].trim() +
        ", " +
        response[2].trim();
    else if (response[0] != "" && response[1] != "" && response[2] == "")
      finalAddress = response[0].trim() + ", " + response[1].trim();
    else if (response[0] != "" && response[1] == "" && response[2] != "")
      finalAddress = response[0].trim() + ", " + response[2].trim();
    else if (response[0] == "" && response[1] != "" && response[2] != "")
      finalAddress = response[1].trim() + " " + response[2].trim();
    else if (response[0] == "" && response[1] == "" && response[2] != "")
      finalAddress = response[2].trim();
    else if (response[0] == "" && response[1] != "" && response[2] == "")
      finalAddress = response[1].trim();
    else if (response[0] != "" && response[1] == "" && response[2] == "")
      finalAddress = response[0].trim();
    else if (response[0] == "" && response[1] == "" && response[2] == "")
      finalAddress = "";
  } else if (lines == 3) {
    if (response[0] != "" && response[1] != "" && response[2] != "")
      finalAddress =
        response[0].trim() +
        ",\n" +
        response[1].trim() +
        ",\n" +
        response[2].trim();
    else if (response[0] != "" && response[1] != "" && response[2] == "")
      finalAddress = response[0].trim() + ",\n," + response[1].trim();
    else if (response[0] != "" && response[1] == "" && response[2] != "")
      finalAddress = response[0].trim() + ",\n," + response[2].trim();
    else if (response[0] == "" && response[1] != "" && response[2] != "")
      finalAddress = response[1].trim() + ",\n" + response[2].trim();
    else if (response[0] == "" && response[1] == "" && response[2] != "")
      finalAddress = response[2].trim();
    else if (response[0] == "" && response[1] != "" && response[2] == "")
      finalAddress = response[1].trim();
    else if (response[0] != "" && response[1] == "" && response[2] == "")
      finalAddress = response[0].trim();
    else if (response[0] == "" && response[1] == "" && response[2] == "")
      finalAddress = "";
  } else {
    return;
  }
  return finalAddress;
};
